import React, { useEffect, useState } from "react";

import {
  Alert,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  Typography,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
} from "@mui/material";
import axios from "axios";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import MUIDataTable from "mui-datatables";
import Loader from "../../../components/loader/Loader";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { addonSchema } from "../../../app/schema";
import { hideConfirmModal, showModal } from "../../../redux/counterSlice";
import { parseArray } from "../../../app/utlils";
import DispatchOrderItem from "./DispatchOrderItem";

function DispatchPanel() {
  const dispatch = useDispatch();
  const { taxList, regionList, userData } = useSelector((state) => state.counter);

  const methods = useForm({
    resolver: yupResolver(addonSchema),
  });
  const {
    handleSubmit,
    control,
    setValue,
    reset,
    formState: { errors },
  } = methods;

  const [loader, setLoader] = useState(true);
  const [formData, setFormData] = useState([]);
  const [open, setOpen] = useState(false);
  const [orderList, setOrderList] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [location, setLocation] = useState(0);
  const [locationList, setLocationList] = useState([]);

  // Get user login type
  const getUserRole = () => {
    return sessionStorage.getItem("loginType") || "admin";
  };

  // Get user's assigned location ID
  const getUserLocationId = () => {
    // check userData or sessionStorage
    
    // For dispatch users, get location_details_id from userData
    const locationId = userData?.location_details_id || sessionStorage.getItem("location_details_id");
    
    // Convert to number if it's a string
    return locationId ? parseInt(locationId) : null;
  };

  const loadInitialData = () => {
    const url = "/getAllActiveLocationDetails";
    setLoader(true);
    axios
      .get(url)
      .then(function (response) {
        const allLocations = response?.data?.data || [];
        const userRole = getUserRole();
        const userLocationId = getUserLocationId();
        
        console.log("User Role:", userRole);
        console.log("User Location ID:", userLocationId);
        console.log("All Locations:", allLocations);
        
        let filteredLocations = allLocations;
        
        // For dispatch users, filter to show only their assigned location
        if (userRole === "dispatch") {
          if (userLocationId) {
            filteredLocations = allLocations.filter(
              (loc) => loc.location_details_id === parseInt(userLocationId)
            );
            
            console.log("Filtered Locations for Dispatch:", filteredLocations);
            
            // Auto-select the dispatch user's location
            if (filteredLocations.length > 0) {
              const dispatchLocation = filteredLocations[0].location_details_id;
              setLocation(dispatchLocation);
              sessionStorage.setItem("dispatch_selected_location", dispatchLocation);
              
              console.log("Auto-selected location:", dispatchLocation);
            } else {
              console.error("No matching location found for dispatch user");
              toast.error("No location assigned to your account");
            }
          } else {
            console.error("Dispatch user has no location_id in userData");
            toast.error("Location information not found. Please contact administrator.");
            filteredLocations = [];
          }
        }
        
        setLocationList(filteredLocations);
      })
      .catch(function (err) {
        console.error("Error loading locations:", err);
        toast.error(err?.message || "Failed to load locations");
      })
      .finally(() => {
        setLoader(false);
        dispatch(hideConfirmModal({ msg: "" }));
      });
  };

  const listAllDispatchOrders = () => {
    if (location > 0) {
      const url = "/getDispatchOrderById/" + location;
      setLoader(true);
      console.log("Fetching orders for location:", location);
      
      axios
        .get(url)
        .then(function (response) {
          console.log("Orders received:", response?.data?.data);
          setOrderList(response?.data?.data || []);
        })
        .catch(function (err) {
          console.error("Error loading orders:", err);
          toast.error(err?.message || "Failed to load orders");
        })
        .finally(() => {
          setLoader(false);
          dispatch(hideConfirmModal({ msg: "" }));
        });
    } else {
      console.log("No location selected, skipping order fetch");
    }
  };

  const handleLocationChange = (value) => {
    console.log("Location changed to:", value);
    setLocation(value);
    sessionStorage.setItem("dispatch_selected_location", value);
  };

  useEffect(() => {
    console.log("Component mounted, loading initial data");
    console.log("Current userData:", userData);
    loadInitialData();
  }, []);

  useEffect(() => {
    console.log("Location changed, fetching orders");
    listAllDispatchOrders();
  }, [location]);

  const userRole = getUserRole();
  const isDispatchUser = userRole === "dispatch";

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <>
          <h4 className="text-dark">Dispatch Panel</h4>
          <Paper
            elevation={1}
            sx={{
              p: 3,
              margin: "auto",
              marginTop: "15px",
              flexGrow: 1,
            }}
          >
            <Grid
              container
              columnSpacing={{ xs: 4 }}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Grid
                item
                xs={4}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  gap: "16px",
                }}
              >
                <FormControl
                  error={errors?.["order_status"]?.message ? true : false}
                  margin="normal"
                  className="w-100"
                  disabled={isDispatchUser} // Disable dropdown for dispatch users
                >
                  <InputLabel id="status_dropdown_label">
                    Processing Team
                  </InputLabel>
                  <Select
                    labelId="status_dropdown_label"
                    id={`status_dropdown_select`}
                    value={location}
                    label="Processing Team"
                    onChange={(e) => handleLocationChange(e?.target?.value)}
                  >
                    {!isDispatchUser && (
                      <MenuItem value={0}>--Select Location--</MenuItem>
                    )}
                    {locationList?.map((item) => (
                      <MenuItem 
                        key={item?.location_details_id}
                        value={item?.location_details_id}
                      >
                        {item?.location_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Grid
                  container
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                  spacing={3}
                >
                  {orderList?.length > 0 ? (
                    <>
                      {orderList.map((dispatch, index) => (
                        <Grid item xs={4} key={index}>
                          <DispatchOrderItem dispatch={dispatch} />
                        </Grid>
                      ))}
                    </>
                  ) : (
                    <Stack sx={{ width: "100%", mt: 3, p: 3 }} spacing={2}>
                      <Alert severity="warning">
                        <h6>No Data Found..</h6>
                      </Alert>
                    </Stack>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </>
      )}
    </>
  );
}

export default DispatchPanel;